import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Document on documents {
    status
    id
  }
`;

export const GET_STATUSES = gql`
  query($userId: Int!, $sub: uuid!) {
    documents(
      where: {
        created_by: { _eq: $userId }
        university_id: { _neq: null }
        deleted: { _eq: false }
      }
    ) {
      status
    }
    appliedCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, category: { _neq: "student" } }
    ) {
      aggregate {
        count
      }
    }
    EarlyActionCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, admission_type: { _eq: "EA" } }
    ) {
      aggregate {
        count
      }
    }
    ResEarlyActionCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, admission_type: { _eq: "REA" } }
    ) {
      aggregate {
        count
      }
    }
    EarlyDecisionCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, admission_type: { _eq: "ED" } }
    ) {
      aggregate {
        count
      }
    }
    RegularDecisionCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, admission_type: { _eq: "REG" } }
    ) {
      aggregate {
        count
      }
    }
    RollingAdmissionCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, admission_type: { _eq: "RO" } }
    ) {
      aggregate {
        count
      }
    }
    OtherAdmissiontypeCount: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, admission_type: { _eq: "other" } }
    ) {
      aggregate {
        count
      }
    }
    statusNotStarted: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _is_null: true } }
    ) {
      aggregate {
        count
      }
    }
    statusinProgress: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "inprogress" } }
    ) {
      aggregate {
        count
      }
    }
    statusSubmitted: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "submitted" } }
    ) {
      aggregate {
        count
      }
    }
    statusDenied: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "denied" } }
    ) {
      aggregate {
        count
      }
    }
    statusWaitlisted: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "waitlist" } }
    ) {
      aggregate {
        count
      }
    }
    statusDefered: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "deferred" } }
    ) {
      aggregate {
        count
      }
    }
    statusAccepted: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "accepted" } }
    ) {
      aggregate {
        count
      }
    }
    statusEnrolled: student_college_aggregate(
      where: { student_sub: { _eq: $sub }, status: { _eq: "enrolled" } }
    ) {
      aggregate {
        count
      }
    }
    nextUniDue: student_college(
      where: {
        student_sub: { _eq: $sub }
        app_deadline: { _neq: null, _gt: "now()" }
        _or: [{ status: { _is_null: true } }, { status: { _eq: "inprogress" } }]
      }
      order_by: { app_deadline: asc }
      limit: 1
    ) {
      university_name: college_name
      due_date: app_deadline
      id
    }
    exercises_done: student_milestone_exercises_aggregate(
      where: {
        user_id: { _eq: $userId }
        status: { _eq: "done" }
        exercise: { type: { _neq: "meeting" } }
      }
    ) {
      aggregate {
        count
      }
    }
    exercises_inprogress: student_milestone_exercises_aggregate(
      where: {
        user_id: { _eq: $userId }
        status: { _eq: "inprogress" }
        exercise: { type: { _neq: "meeting" } }
      }
    ) {
      aggregate {
        count
      }
    }
    exercises_notstarted: student_milestone_exercises_aggregate(
      where: {
        user_id: { _eq: $userId }
        status: { _is_null: true }
        exercise: { type: { _neq: "meeting" } }
      }
    ) {
      aggregate {
        count
      }
    }
    exercises_count: student_milestone_exercises_aggregate(
      where: {
        user_id: { _eq: $userId }
        exercise: { type: { _neq: "meeting" } }
      }
    ) {
      aggregate {
        count
      }
    }
    credits: v_meeting_credits(where: { user_id: { _eq: $userId } }) {
      user_id
      credit_type
      available
      credit
      debit
    }
    subscriptions(where:{student_id: {_eq: $userId}}) {
        end_date
    }  
  }
`;

export const GET_CREDIT_SUMMARY = gql`
  query getCreditSummary($userId: Int) {
    v_meeting_credits(where: { user_id: { _eq: $userId } }) {
      user_id
      credit_type
      available
      credit
      debit
    }
  }
`;
